import React, { Component } from "react";
import { history } from "../../app/AppRouter";
import { connect } from "react-redux";
import { NavLink } from "react-router-dom";
import AddDropdown from "./AddDropdown";
import Button from "../../components/buttons/primaryButton";
import { getNavigationConfig } from "../../contents/icons";
import { toastr } from "react-redux-toastr";
import {
  createTrainer,
  createClass,
  getAllTrainers,
  getPackages,
  createCourt,
  getGymFeatures,
  saveGymSettings,
} from "../../redux/actions/api/apiAction";
import { store } from "../../redux/storeConfig/store";
import { Modal, ModalBody } from "reactstrap";
import collapse from "../../assets/images/Collapse Menu.svg";
import expand from "../../assets/images/Expand Menu.svg";
import {
  setSidebarStatus,
  addTrainerModal,
  addUserModal,
  setRetailModal,
  addPrivateModal,
  addWodModal,
  setAlertModal,
  addPackageModal,
  addSaleModal,
  addStaffModal,
  addAppointmentModal,
  addServiceModal,
  collapseSideBar,
  addGateModal,
  setCourtModal,
  addWorkshopModal,
  addFollowupProgramModal,
} from "../../redux/actions/sidebar/sidebarAction";
import "react-datepicker/dist/react-datepicker.css";
import { ComonIcons } from "../../contents/commonIcons";
import MultiStep from "../trainer/trainerForm";
import WodForm from "../wod/wodForm";
import FollowupProgramForm from "../followupProgram/followupProgramForm";
import GateForm from "../gate/gateForm";
import MultiStepForPackage from "../package/packageForm";
import MultiStepForSale from "../sale/saleForm";
import StaffForm from "../staff/staffForm";
import MultiStepForMember from "../member/memberForm";
import {
  draftFormProps,
  memberFormProps,
  packageFormProps,
} from "../voiceAdd/openForm";
import MultiStepForRetail from "../retail/retailForm";
import MultiStepCourt from "../court/courtForm";
import ClassForm from "../class/class";
import moment from "moment";
import { AddAppointment } from "../appointment/addAppointment";
import { AddService } from "../services_products/addServiceModal";
import { SideDropDown } from "./sideDropDown";
import WorkshopMain from "../class/workshop";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { setOpenLeadModal } from "../../redux/actions/lead/leadAction";
import LeadMainForm from "../lead/leadMainForm";

const getUTCDateTime = (newdate, time) => {
  let date = moment(newdate).format("MM/DD/YYYY");
  let hour = new Date(`${date} ${time}`).getUTCHours();
  let min = new Date(`${date} ${time}`).getUTCMinutes();
  let dateUTC = new Date(`${date} ${time}`).getUTCDate();
  let monthUTC = new Date(`${date} ${time}`).getUTCMonth();
  let yearUTC = new Date(`${date} ${time}`).getUTCFullYear();
  let newTime = new Date(`${monthUTC + 1}/${dateUTC}/${yearUTC} UTC`).getTime();

  return {
    date: newTime,
    time: `${hour}:${min}:00`,
    newDate: `${monthUTC + 1}/${dateUTC}/${yearUTC}`,
  };
};

const getLocalDateTime = (newdate, time) => {
  let date = moment(newdate).format("MM/DD/YYYY");
  let hour = new Date(`${date} ${time} UTC`).getHours();
  let min = new Date(`${date} ${time} UTC`).getMinutes();
  let dateUTC = new Date(`${date} ${time} UTC`).getDate();
  let monthUTC = new Date(`${date} ${time} UTC`).getMonth();
  let yearUTC = new Date(`${date} ${time} UTC`).getFullYear();
  let newTime = new Date(`${monthUTC + 1}/${dateUTC}/${yearUTC} UTC`).getTime();

  return {
    date: newTime,
    time: `${hour}:${min}:00`,
    newDate: `${monthUTC + 1}/${dateUTC}/${yearUTC}`,
  };
};
const Week = {
  0: "sun",
  1: "mon",
  2: "tue",
  3: "wed",
  4: "thu",
  5: "fri",
  6: "sat",
};

const FindDatesOfClass = (startDate, endDate, repeatDays) => {
  let response = [];
  let local = moment(startDate).format("MM/DD/YYYY");
  let local2 = moment(endDate).format("MM/DD/YYYY");
  let start = new Date(`${local} UTC`);
  let end = new Date(`${local2} UTC`);

  let loop = start;
  while (loop <= end) {
    if (repeatDays.includes(Week[loop.getDay()])) {
      response.push(loop.getTime());
    }
    let newDate = loop.setDate(loop.getDate() + 1);
    loop = new Date(newDate);
  }
  return response;
};

const getNewUTCTimes = (dates, time) => {
  let newArray = [];
  dates.map((one) => {
    let data = getUTCDateTime(one, time).date;
    newArray.push(data);
  });
  return newArray;
};

const isSidebarAccessReady = (props) => {
  const user = props.loginUser || {};
  if (user.role === "STAFF" && !props.permissionsLoaded) return false;
  if (
    user.isSuperGymAdmin &&
    (!props.subAdminPermissionsLoaded || !props.subAdminType)
  ) {
    return false;
  }
  return true;
};

class Sidebar extends Component {
  constructor(props) {
    super(props);
    this.sideBarRef = React.createRef();
    this.toggle = this.toggle.bind(this);
    const gymReady = Boolean(props.gym && props.gym.id);
    const accessReady = isSidebarAccessReady(props);
    this.state = {
      dropdownOpen: false,
      staffPermissions: [],
      services: false,
      bookings: false,
      navigationConfig: gymReady ? getNavigationConfig(props.gym) : [],
      navReady: gymReady && accessReady,
    };
  }
  state = {
    sidebarOpen: false,
    addModal: false,
  };
  showGatesFeature =
    !this.props.loginUser.role || this.props.loginUser.role === "STAFF"
      ? this.props.permissions["S-GATES-FEAT"]
        ? true
        : false
      : true;

  sidebarToggle() {
    this.setState({
      sidebarOpen: !this.state.sidebarOpen,
    });
  }
  addTrainer = async () => {
    this.props.addTrainerModal(!this.props.trainerModal);
  };

  addPrivate = async () => {
    //console.log("133131313");
    if (!this.props.privateModal) {
      await this.props.getAllTrainers(
        1,
        999999,
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym,
        "",
        "",
        "Y"

      );
    }
    this.props.addPrivateModal(!this.props.privateModal);
  };
  addWorkshop = async () => {
    //console.log("133131313");
    if (!this.props.workshopModal) {
      await this.props.getAllTrainers(
        1,
        999999,
        JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym,
        "",
        "",
        "Y"
      );
    }
    this.props.addWorkshopModal(!this.props.workshopModal);
  };
  addWod = async () => {
    this.props.addWodModal(!this.props.wodModal);
  };
  addFollowupProgram = async () => {
    this.props.addFollowupProgramModal(!this.props.followupProgramModal);
  };

  alertModal = () => {
    this.props.setAlertModal(!this.props.alertModal);
  };
   toggleAddLead = () => {
    this.props.setOpenLeadModal(!this.props.openLeadModal);
  };
  updateNavigationConfig(gym) {
    if (!gym || !gym.id) return;
    const navigationConfig = getNavigationConfig(gym);
    this.setState({
      navigationConfig,
      navReady: isSidebarAccessReady(this.props),
    });
  }
  renderMenuSkeleton() {
    return Array.from({ length: 8 }, (_, index) => (
      <li className="list-element" key={`sidebar-skeleton-${index}`}>
        <div className="link-blk" style={{ pointerEvents: "none" }}>
          <div className="link-data">
            <div className="link-img">
              <span
                className="sidebar-menu-skeleton"
                style={{ width: 22, height: 22 }}
              />
            </div>
            {!this.props.collapsed && (
              <div
                className="sidebar-menu-skeleton"
                style={{
                  height: 14,
                  width: `${48 + (index % 4) * 10}%`,
                  maxWidth: 160,
                }}
              />
            )}
          </div>
        </div>
      </li>
    ));
  }
  componentDidMount() {
    // this.props.getGymFeatures(this.props.gym);
    this.updateNavigationConfig(this.props.gym);

    this.props.collapsed
      ? (this.sideBarRef.current.style.width = "88px")
      : (this.sideBarRef.current.style.width = "300px");
    function scroll() {
      let getMeTo = document.getElementById(window.location.pathname);
      if (getMeTo) getMeTo.scrollIntoView({ behavior: "smooth" }, true);
    }
    setTimeout(() => {
      scroll();
    }, 300);
  }
  toggle() {
    this.setState((prevState) => ({
      dropdownOpen: !prevState.dropdownOpen,
    }));
  }

  createTrainer = async ({
    name,
    email,
    phone,
    image,
    activeStatus,
    payRates,
    qualifications,
    canLive,
    dob,
    scheduleDays,
    trainerAttributes,
    gender,
    addTrainerAsMember,
  }) => {
    const scheduleDaysKeys = Object.keys(scheduleDays);
    let allEmpty = true;
    for (let day of scheduleDaysKeys) {
      if (scheduleDays[day].length) {
        allEmpty = false;
        break;
      }
    }

    if (allEmpty) {
      for (let day of scheduleDaysKeys) {
        scheduleDays[day].push({ start: "05:00", end: "23:00" });
      }
    }
    let memberData;
    if (addTrainerAsMember) {
      memberData = {
        name,
        firstName: name,
        email,
        phone,
        relations: [],
        country: JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))
          .country,
        image,
        gender,
        dob,
      };
    }
    store.dispatch(
      createTrainer(
        {
          name,
          email,
          phone,
          image,
          activeStatus,
          payRates,
          qualities: qualifications.toString(),
          canLive,
          trainerAttributes,
          gender,
          dob,
          scheduleDays,
          role: "TRAINER",
          gym: JSON.parse(localStorage.getItem("connectToFitGymPanelUser")).gym,
          addTrainerAsMember,
        },
        memberData
      )
    );
  };
  createCourt = async ({
    name,
    type,
    // scheduleDays,
    dateIntervals,
    isRestricted,
    isPublished
  }) => {
    // const scheduleDaysKeys = Object.keys(scheduleDays);
    // let allEmpty = true;
    // for (let day of scheduleDaysKeys) {
    //   if (scheduleDays[day].length) {
    //     allEmpty = false;
    //     break;
    //   }
    // }

    // if (allEmpty) {
    //   for (let day of scheduleDaysKeys) {
    //     scheduleDays[day].push({ start: "00:00", end: "23:59" });
    //   }
    // }

    store.dispatch(
      createCourt({
        name,
        type,
        // scheduleDays,
        dateIntervals,
        isRestricted,
        isPublished
      })
    );
  };

  handleSubmit = async (values) => {
    let daysArray = values.day.map((one, index) => {
      return one.slice(0, 3).toLowerCase();
    });
    let data = {
      name: values.name,
      trainer: !values.trainer ? null : values.trainer,
      capacity: values.capacity,
      waitingList: values.waitingList,
      price: values.price,
      location: values.location,
      type: values.type,
      repeatDays: daysArray.join(","),
      startDate: values.startDate,
      endDate: values.endDate,
      from: getUTCDateTime(values.startDate, values.from).time,
      to: getUTCDateTime(values.endDate, values.to).time,
      members: values.members || [],
      image: values.type !== "OFFLINE" ? values.image : "",
    };
    let check = FindDatesOfClass(data.startDate, data.endDate, data.repeatDays);
    if (check.length > 0) {
      data.classDates = getNewUTCTimes(
        check,
        getLocalDateTime(data.startDate, data.from).time
      );
      await store.dispatch(createClass(data));
    } else toastr.error("No selected day found in selected date range");
  };

  goToInfo = () => {
    this.alertModal();
    if (
      this.props.loginUser.role === "GYM" ||
      this.props.loginUser.role === "STAFF"
    )
      history.push("/gym-panel/gyminfoedit");
    else history.push("/trainer-panel/trainerinfo/edit");
  };

  componentDidUpdate = (prevProps) => {
    function scroll() {
      let getMeTo = document.getElementById(window.location.pathname);
      if (getMeTo) getMeTo.scrollIntoView({ behavior: "smooth" }, true);
    }
    setTimeout(() => {
      scroll();
    }, 300);

    this.props.collapsed
      ? (this.sideBarRef.current.style.width = "88px")
      : (this.sideBarRef.current.style.width = "300px");

    if (prevProps.gym !== this.props.gym) {
      if (this.props.gym?.id) {
        this.props.getGymFeatures(this.props.gym.id);
      }
      this.updateNavigationConfig(this.props.gym);
    }
    if (
      prevProps.permissionsLoaded !== this.props.permissionsLoaded ||
      prevProps.subAdminPermissionsLoaded !== this.props.subAdminPermissionsLoaded ||
      prevProps.subAdminType !== this.props.subAdminType
    ) {
      this.updateNavigationConfig(this.props.gym);
    }
    if (
      prevProps.unreadNotificationCount !== this.props.unreadNotificationCount &&
      this.props.gym?.id &&
      this.state.navReady
    ) {
      this.updateNavigationConfig(this.props.gym);
    }
  };
  handleCollapse = () => {
    store.dispatch(collapseSideBar());
  };
    handleDragEnd = (result) => {
      if (!result.destination) return;
      const items = Array.from(this.state.navigationConfig).filter((el)=>el.show);
      const [reorderedItem] = items.splice(result.source.index, 1);
      items.splice(result.destination.index, 0, reorderedItem);

      // update state for UI
      this.setState({ navigationConfig: items });

      // build the order array (just IDs)
      const order = items.map(item => item.id);
    // this.setState({ navigationConfig: items });
    const newSettings = {
        ...this.props?.gym?.settings,
        general: {
          ...this.props?.gym?.settings?.general,
          sideBarOrder: order,
        },
      };
      store.dispatch(saveGymSettings({settings:newSettings}));
  };
  render() {
    let userData = JSON.parse(localStorage.getItem("connectToFitGymPanelUser"));
    return (
      <div
        ref={this.sideBarRef}
        className={this.props.sidebarStatus ? "sidebar active" : "sidebar"}
      >
        <nav id="sidebar" className="sidebar-wrapper">
          <div className="sidebar-main-block ">
            {!this.props.broken && (
              <img
                onClick={this.handleCollapse}
                src={this.props.collapsed ? expand : collapse}
                alt="collapse"
                className="collapse-icon"
              />
            )}
            <div className="user-main-block position-relative">
              <div
                className="user-img-block"
                style={
                  this.props.collapsed
                    ? {
                        width: "55px",
                        height: "55px",
                        position: "relative",
                        right: "15px",
                      }
                    : {}
                }
              >
                {this.props.gym?.id ? (
                  <img
                    src={
                      this.props.gym.user && this.props.gym.user.image
                        ? this.props.gym.user.image
                        : require("../../assets/images/no_image.jpg")
                    }
                    className="img-fluid"
                    id="gymImg"
                    alt=""
                  />
                ) : (
                  <div
                    className="sidebar-menu-skeleton"
                    style={{ width: "100%", height: "100%", borderRadius: "50%" }}
                  />
                )}
                <img
                  src={
                    JSON.parse(localStorage.getItem("connectToFitGymPanelUser"))
                      .image
                      ? JSON.parse(
                          localStorage.getItem("connectToFitGymPanelUser")
                        ).image
                      : require("../../assets/images/user.svg")
                  }
                  className="img-fluid"
                  alt=""
                />
              </div>
              {!this.props.collapsed && (
                <div className="username">
                  {this.props.gym?.id ? (
                    <h4 className="f-bold mb-0">
                      {this.props.gym.user && this.props.gym.user.name}
                    </h4>
                  ) : (
                    <div
                      className="sidebar-menu-skeleton mx-auto"
                      style={{ height: 18, width: "70%" }}
                    />
                  )}
                  {this.props.loginUser.role === "STAFF" && (
                    <h4 className="f-bold mb-0 mt-3">
                      {userData && userData.name}
                    </h4>
                  )}
                </div>
              )}
              <div
                className="close-icon-sidebar"
                onClick={() => {
                  this.props.setSidebarStatus(!this.props.sidebarStatus);
                }}
              >
                {ComonIcons.close}
              </div>
            </div>
            <div className="seperator"></div>
          </div>
          <div className="sidebar-dropdown">
            {this.state.navReady ? (
            <AddDropdown
              collapsed={this.props.collapsed}
              addtoggle={() => {
                this.props.addGymModal(!this.props.gymModal);
              }}
              addTrainerModal={() => {
                this.props.addTrainerModal(!this.props.trainerModal);
              }}
              addAdminModal={() => {
                this.props.addAdminModal(!this.props.adminModal);
              }}
              addUserModal={() => {
                this.props.addUserModal(!this.props.userModal);
              }}
              setRetailModal={() => {
                this.props.setRetailModal(!this.props.retailModal);
              }}
              setCourtModal={() => {
                this.props.setCourtModal(!this.props.courtModal);
              }}
              addPrivateModal={() => {
                this.addPrivate();
              }}
              addWorkshopModal={() => {
                this.addWorkshop();
              }}
              addWodModal={() => {
                this.props.addWodModal(!this.props.wodModal);
              }}
              addFollowupProgramModal={() => {
                this.props.addFollowupProgramModal(!this.props.followupProgramModal);
              }}
              addGateModal={() => {
                this.props.addGateModal(!this.props.gateModal);
              }}
              staffPermissons={(p) => this.setState({ staffPermissions: p })}
            />
            ) : (
              <div
                className="sidebar-menu-skeleton"
                style={{
                  height: 38,
                  width: this.props.collapsed ? 40 : "100%",
                  margin: this.props.collapsed ? "0 auto" : undefined,
                }}
              />
            )}
          </div>
          <div className="pages-main-link-block">
              <div className="list-ul">
                {this.state.navReady ? (
                <DragDropContext onDragEnd={this.handleDragEnd}>
                  <Droppable droppableId="sidebar">
                    {(provided) => (
                      <ul
                        className="list-main-block"
                        ref={provided.innerRef}
                        {...provided.droppableProps}
                      >
                        {this.state.navigationConfig
                          .filter((val) => val.show)
                          .map((value, index) => {
                            // 👇 KEEPING YOUR EXISTING LOGIC
                            if (value.dropdownMenu) {
                              value.dropdownMenu = value.dropdownMenu.filter(
                                (val) => val.show
                              );
                            }
                            if (value.id == "gate" && !this.showGatesFeature) {
                              return null;
                            }
                            if (
                              value.id == "courts" &&
                              this.props.gym.id &&
                              this.props.gym.type != "sportClub" &&
                              this.props.gym.type != "complex"
                            ) {
                              return null;
                            }
                            if (
                              value.id == "courts" &&
                              this.props.gym.id &&
                              this.props.gym.type == "complex"
                            ) {
                              value.title = "Rooms";
                            }
                            if (
                              value.id == "bookings" &&
                              this.props.gym.id &&
                              this.props.gym.type != "sportClub" &&
                              this.props.gym.type != "complex"
                            ) {
                              value.dropdownMenu.forEach((item, idx) => {
                                if (item.id == "courtBooking") {
                                  value.dropdownMenu.splice(idx, 1);
                                }
                              });
                            }
                            if (
                              value.id == "bookings" &&
                              this.props.gym.type == "sportClub"
                            ) {
                              value.title = "Planning";
                              value.dropdownMenu = value.dropdownMenu
                                .filter(
                                  (item) =>
                                    item.id == "courtBooking" || item.id == "class"
                                )
                                .map((el) =>
                                  el.id == "class" &&this.props?.gymConfig?.manageMemberships?.enabled && this.props.gymConfig?.manageMemberships?.classMemberships?.enabled
                                    ? { ...el, name: "Group Session" }
                                    : el.id == "class" &&this.props?.gymConfig?.manageMemberships?.enabled && this.props.gymConfig?.manageMemberships?.workshopAndCoursesMemberships?.enabled?{ ...el, name: "Workshop/Course" }: el
                                );
                            }
                            if (
                              value.id == "bookings" &&
                              this.props.gym.type == "complex"
                            ) {
                              value.title = "Bookings";
                              value.dropdownMenu = value.dropdownMenu
                                .filter(
                                  (item) =>
                                    item.id == "courtBooking" || item.id == "class"
                                )
                                .map((el) =>
                                  el.id == "courtBooking"
                                    ? { ...el, name: "Rooms and Appointments" }
                                    : el
                                );
                            }
                            if (
                              value.id == "instructors" &&
                              this.props.gym.id &&
                              this.props.gym.type == "sportClub"
                            ) {
                              value.title = "Coaches";
                            }
                            if (
                              value.id == "instructors" &&
                              this.props.gym.id &&
                              this.props.gym.type == "complex"
                            ) {
                              value.title = "Instructor";
                            }

                            if (
                              value.code &&
                              (Array.isArray(value.code)
                                ? (this.props.loginUser.role === "STAFF" &&
                                    !value.code.some(
                                      (code) => this.props.permissions[code]
                                    )) ||
                                  (this.props.subAdminType === "SUB_ADMIN" &&
                                    !value.code.some(
                                      (code) =>
                                        this.props.subAdminPermissions[code]
                                    ))
                                : (this.props.loginUser.role === "STAFF" &&
                                    !this.props.permissions[value.code]) ||
                                  (this.props.subAdminType === "SUB_ADMIN" &&
                                    !this.props.subAdminPermissions[value.code]))
                            ) {
                              return null;
                            }

                            // 👇 WRAP IN DRAGGABLE
                            return (
                             <Draggable key={value.id} draggableId={value.id} index={index}>
                                {(provided) => (
                                  <li
                                    ref={provided.innerRef}
                                    {...provided.draggableProps}
                                    {...provided.dragHandleProps}
                                    className={
                                      value.type !== "collapse"
                                        ? `list-element ${
                                            history.location.pathname.includes(value.navLink)
                                              ? "active"
                                              : " "
                                          }`
                                        : ""
                                    }
                                    id={value.type !== "collapse" ? window.location.pathname : undefined}
                                  >
                                    {value.type === "collapse" ? (
                                      <SideDropDown
                                        collapsed={this.props.collapsed}
                                        key={value.id}
                                        title={value.title}
                                        icon={value.icon}
                                        classModal={this.addPrivate}
                                        appointmentModal={this.props.addAppointmentModal}
                                        dropdownMenu={value.dropdownMenu}
                                        isPages={value.isPages}
                                        sideBarCollapsed={this.props.collapsed}
                                      />
                                    ) : (
                                      <>
                                        <div className="curve">
                                          <div className="list-element-upper-curve"></div>
                                        </div>

                                        <NavLink exact to={value.navLink} className="link-blk">
                                          <div className="link-data">
                                            <div className="link-img">{value.icon}</div>

                                            {!this.props.collapsed && (
                                              <div className="link-text">{value.title}</div>
                                            )}
                                          </div>
                                        </NavLink>

                                        <div className="curve-2">
                                          <div className="list-element-upper-curve-2"></div>
                                        </div>
                                      </>
                                    )}
                                  </li>
                                )}
                            </Draggable>

                            );
                          })}
                        {provided.placeholder}
                      </ul>
                    )}
                  </Droppable>
                </DragDropContext>
                ) : (
                  <ul className="list-main-block">{this.renderMenuSkeleton()}</ul>
                )}
              </div>
          </div>
        </nav>
        {/* <div className="side-bar-footer">
          <div className="out-block">
            <Link
              to="/"
              className="link-main-block"
              onClick={() => store.dispatch(logout(userData.id))}
            >
              <div className="link-data">
                <div className="d-flex align-items-center">
                  <div className="link-img">{ComonIcons.signout}</div>
                  <div className="content">Sign Out</div>
                </div>
              </div>
            </Link>
          </div>
        </div> */}

        {/* adding Trainer pop up  for use it   */}
        <Modal
          isOpen={this.props.trainerModal}
          toggle={() => {
            this.props.addTrainerModal(!this.props.trainerModal);
          }}
          centered={true}
          size="xl"
          className="large-pop adding-popup add-gym-popup"
        >
          <MultiStep
            handleSubmit={this.createTrainer}
            {...draftFormProps(this.props.voicePrefill, "instructor")}
          />
        </Modal>

        <Modal
          isOpen={this.props.courtModal}
          toggle={() => {
            this.props.setCourtModal(!this.props.courtModal);
          }}
          centered={true}
          size="xl"
          className="large-pop adding-popup add-gym-popup"
        >
          <MultiStepCourt
            handleSubmit={this.createCourt}
            {...draftFormProps(this.props.voicePrefill, "court")}
          />
        </Modal>
        {/* adding user/member pop up  for use it   */}
        <Modal
          isOpen={this.props.userModal}
          toggle={() => {
            //don't close modal on click outside, entered data will be missed
          }}
          centered={true}
          size="xl"
          className="large-pop adding-popup add-member-popup"
        >
          {/*For Member*/}
          <MultiStepForMember
            packages={this.props.packages}
            {...memberFormProps(this.props.voicePrefill)}
          />
        </Modal>

        {/**Adding product Retail */}
        <Modal
          isOpen={this.props.retailModal}
          toggle={() => {
            this.props.setRetailModal(!this.props.retailModal);
          }}
          centered={true}
          size="xl"
          className="large-pop adding-popup add-member-popup"
        >
          {/*For Member*/}
          <MultiStepForRetail
            {...draftFormProps(this.props.voicePrefill, "product")}
          />
        </Modal>

        {/**For Add class */}
        <Modal
          isOpen={this.props.privateModal}
          toggle={() => {
            this.addPrivate();
          }}
          centered={true}
          size="xl"
          className="large-pop adding-popup add-member-popup"
        >
          <ClassForm
            handleSubmit={this.handleSubmit}
            addPrivate={this.addAppointmentModal}
            canLive={this.props.gym.canLive}
          />
        </Modal>
        {/**For Add workshop */}
        <Modal
          isOpen={this.props.workshopModal}
          toggle={() => {
            this.addWorkshop();
          }}
          centered={true}
          size="xl"
          className="large-pop adding-popup add-member-popup"
        >
          <WorkshopMain
            toggle={() => {
              this.addWorkshop();
            }}
          />
        </Modal>
        {/* ADD APPOINTMENT */}
        <Modal
          isOpen={this.props.appointmentModal}
          toggle={() => {
            this.props.addAppointmentModal();
          }}
          centered={true}
          size="xl"
          className="large-pop adding-popup add-member-popup"
        >
          <AddAppointment toggleModal={this.props.addAppointmentModal} />
        </Modal>
        {/* ADD SERVICE OR PRODUCT */}
        <Modal
          isOpen={this.props.serviceModal}
          toggle={() => {
            this.props.addServiceModal(!this.props.serviceModal);
          }}
          centered={true}
          size="xl"
          className="large-pop adding-popup add-member-popup"
        >
          <AddService />
        </Modal>
        {/* Wod */}
        <Modal
          isOpen={this.props.wodModal}
          toggle={() => {
            this.props.addWodModal(!this.props.wodModal);
          }}
          centered={true}
          size="xl"
          className="wod-popup large-pop adding-popup add-gym-popup"
        >
          {/* <MultiStep handleSubmit={this.createWod} /> */}
          <WodForm {...draftFormProps(this.props.voicePrefill, "workout")} />
        </Modal>
        {/* Followup Program */}
        <Modal
          isOpen={this.props.followupProgramModal}
          toggle={() => {
            this.props.addFollowupProgramModal(!this.props.followupProgramModal);
          }}
          centered={true}
          size="xl"
          className="wod-popup large-pop adding-popup add-gym-popup"
        >
          <FollowupProgramForm
            {...draftFormProps(this.props.voicePrefill, "followup")}
          />
        </Modal>
        <Modal
          isOpen={this.props.gateModal}
          toggle={() => {
            this.props.addGateModal(!this.props.gateModal);
          }}
          centered={true}
          size="xl"
          className="wod-popup large-pop adding-popup add-gym-popup"
        >
          <GateForm
            isEdit={this.props.gateEdit}
            gateId={this.props.gateEditFields?.id}
            name={this.props.gateEditFields?.name || ""}
            type={this.props.gateEditFields?.type || ""}
            linkedClasses={this.props.gateEditFields?.linkedClasses?.map(c => c.id) || []}
            {...draftFormProps(this.props.voicePrefill, "gate")}
          />
        </Modal>

        <Modal
          isOpen={this.props.packageModal}
          toggle={() => {
            this.props.addPackageModal(!this.props.packageModal, false, {});
          }}
          centered={true}
          size="xl"
          className="wod-popup add-package-modal large-pop adding-popup add-gym-popup"
        >
          <MultiStepForPackage {...packageFormProps(this.props.voicePrefill)} />
        </Modal>
        <Modal
          isOpen={this.props.saleModal}
          toggle={() => {
            this.props.addSaleModal(!this.props.saleModal, false, {});
          }}
          centered={true}
          size="xl"
          className="wod-popup add-package-modal large-pop adding-popup add-gym-popup"
        >
          <MultiStepForSale members={this.props.allMembers} />
        </Modal>
        <Modal
          isOpen={this.props.staffModal}
          toggle={() => {
            this.props.addStaffModal(!this.props.staffModal, false, {});
          }}
          centered={true}
          size="xl"
          className="wod-popup add-package-modal large-pop adding-popup add-gym-popup"
        >
          <StaffForm
            permissionsList={this.state.staffPermissions}
            {...draftFormProps(this.props.voicePrefill, "staff")}
          />
        </Modal>

        <Modal
          isOpen={
            (this.props.loginUser.role == "STAFF" &&
              !this.props.permissions["S-INF"]) ||
            (this.props.loginUser.role == "SUB_ADMIN" &&
              !this.props.permissions["S-INF"])
              ? false
              : this.props.alertModal
          }
          toggle={this.alertModal}
          centered={true}
          className="small-pop delete-pop"
        >
          <ModalBody>
            <div className="modal-body-content">
              <div className="content">
                <div className="delete-title">
                  <h4 className="f-bold">Important Info</h4>
                </div>
                <div className="delete-data">
                  <h5>
                    Please complete your profile to appear on website.
                    <br />
                    {"if done, ignore this message"}
                  </h5>
                </div>
              </div>
              <div className="action-btn-block">
                <Button
                  type="button"
                  value="Cancel"
                  styleClass="btn-small btn-danger"
                  onClick={this.alertModal}
                />
                <Button
                  type="button"
                  value="Add Info"
                  styleClass="btn-small"
                  onClick={() => this.goToInfo()}
                />
              </div>
            </div>
          </ModalBody>
        </Modal>
          <Modal
          isOpen={
          this.props.openLeadModal
          }
          toggle={this.toggleAddLead}
          centered={true}
           size="xl"
          className="wod-popup add-package-modal large-pop adding-popup add-gym-popup"
        >
          <ModalBody>
              <LeadMainForm
                {...draftFormProps(this.props.voicePrefill, "lead")}
              />
          </ModalBody>
        </Modal>
        
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const {
    sidebarStatus,
    trainerModal,
    userModal,
    retailModal,
    privateModal,
    wodModal,
    alertModal,
    packageModal,
    saleModal,
    staffModal,
    appointmentModal,
    serviceModal,
    collapsed,
    gateModal,
    gateEdit,
    gateEditFields,
    courtModal,
    workshopModal,
    followupProgramModal,
  } = state.sidebar;
  const { gym, gymConfig } = state.gym;
  const { loginUser } = state.login;
  const { packages } = state.packages;
  const { allMembers } = state.member;
  const {
    permissions,
    permissionsLoaded,
    subAdminType,
    subAdminPermissions,
    subAdminPermissionsLoaded,
  } = state.permissions;
  const { unreadNotificationCount } = state.notification;
  const {openLeadModal}=state.leads
  const voicePrefill = state.voiceAdd && state.voiceAdd.prefill;

  return {
    sidebarStatus,
    trainerModal,
    userModal,
    retailModal,
    privateModal,
    workshopModal,
    wodModal,
    gym,
    loginUser,
    alertModal,
    packages,
    packageModal,
    saleModal,
    allMembers,
    staffModal,
    permissions,
    permissionsLoaded,
    appointmentModal,
    serviceModal,
    collapsed,
    subAdminType,
    subAdminPermissions,
    subAdminPermissionsLoaded,
    gateModal,
    gateEdit,
    gateEditFields,
    courtModal,
    unreadNotificationCount,
    gymConfig,
    followupProgramModal,
    openLeadModal,
    voicePrefill,
  };
};
export default connect(mapStateToProps, {
  setSidebarStatus,
  addTrainerModal,
  addUserModal,
  setRetailModal,
  addPrivateModal,
  addWorkshopModal,
  addWodModal,
  getAllTrainers,
  setAlertModal,
  getPackages,
  addPackageModal,
  addSaleModal,
  addStaffModal,
  addAppointmentModal,
  addServiceModal,
  collapseSideBar,
  addGateModal,
  setCourtModal,
  getGymFeatures,
  addFollowupProgramModal,
  setOpenLeadModal
})(Sidebar);
